<template>
  <alert :show="show">
    <template v-slot:title>
      <template v-if="chooseNew">{{
        $t("components.list.list_choose_confirmation.question_to_follow")
      }}</template
      ><template v-else>{{
        $t("components.list.list_choose_confirmation.question_to_unfollow")
      }}</template>
    </template>
    <template v-slot:content v-if="chooseNew"
      ><p class="text-center text-chplus-regular">
        {{ $t("components.list.list_choose_confirmation.info_to_follow") }}
      </p></template
    >
    <template v-slot:footer>
      <div class="flex w-full">
        <navigate-small-button
          :theme="'border-interaction-dark'"
          @click="cancel"
          class="flex-1 uppercase"
          style="margin-right: 3%"
        >
          <template v-if="chooseNew">{{
            $t("components.list.list_choose_confirmation.button_no_follow")
          }}</template
          ><template v-else>{{
            $t("components.list.list_choose_confirmation.button_no_unfollow")
          }}</template>
        </navigate-small-button>
        <navigate-small-button
          :theme="'contrast-light'"
          @click="confirm"
          class="flex-1"
        >
          <template v-if="chooseNew">{{
            $t("components.list.list_choose_confirmation.button_yes_follow")
          }}</template
          ><template v-else>{{
            $t("components.list.list_choose_confirmation.button_yes_unfollow")
          }}</template>
        </navigate-small-button>
      </div>
    </template>
  </alert>
</template>

<script>
import Alert from "@/components/layouts/Alert";
import NavigateSmallButton from "@/components/buttons/NavigateSmallButton";
export default {
  name: "ListChooseConfirmation",
  components: { NavigateSmallButton, Alert },
  props: {
    chooseNew: {
      type: Boolean,
      default: true
    },
    callback: {
      type: Function,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirm() {
      this.close(true);
    },
    cancel() {
      this.close(false);
    },
    close(confirm) {
      if (this.callback) this.callback(confirm);
    }
  }
};
</script>

<style scoped></style>
